import { render, staticRenderFns } from "./TagsType.vue?vue&type=template&id=b674ef4c&scoped=true&"
import script from "./TagsType.vue?vue&type=script&lang=js&"
export * from "./TagsType.vue?vue&type=script&lang=js&"
import style0 from "./TagsType.vue?vue&type=style&index=0&id=b674ef4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b674ef4c",
  null
  
)

export default component.exports